<footer>
  <div class="logo">
    <img src="assets/Ipam-logo.svg" />
  </div>
  <div class="company-name">شرکت ایپام (ایده پرداز دانش نوین آرشام)</div>
  <div class="menu">
    <div class="item" routerLink="/">خانه</div>
    <div class="item" routerLink="/about-us">درباره ایپام</div>
    <div class="item" routerLink="/solutions/exclusive">راه‌کارهای اختصاصی</div>
    <div class="item" routerLink="/job-offer">فرصت‌های شغلی</div>
    <div class="item" routerLink="/contact-us">تماس با ما</div>
  </div>
  <div class="info">
    <div class="item">
      <i [inlineSVG]="'assets/icons/location.svg'"></i>
      <span> میرداماد، خیابان نفت شمالی، تقاطع خیابان نیل و خیابان پیروز شرقی، پلاک 18، ساختمان ایپام</span>
    </div>
  </div>
  <div class="info">
    <div class="item">
      <i [inlineSVG]="'assets/icons/call.svg'"></i>
      <span dir="ltr">021 - 79537</span>
    </div>
    <div class="item">
      <i [inlineSVG]="'assets/icons/mail.svg'"></i>
      <span>info@ipaam.ir</span>
    </div>
  </div>
  <div class="text-center">
    <a referrerpolicy="origin" style="margin-left: 16px" target="_blank" href="https://trustseal.enamad.ir/?id=279599&amp;Code=e9aL1pd6cNireYLDPE0h"
      ><img
        referrerpolicy="origin"
        src="https://Trustseal.eNamad.ir/logo.aspx?id=279599&amp;Code=e9aL1pd6cNireYLDPE0h"
        alt=""
        style="cursor: pointer"
        id="e9aL1pd6cNireYLDPE0h"
    /></a>
    <img
      referrerpolicy="origin"
      id="nbqejzpergvjesgtoeukoeuk"
      style="cursor: pointer"
      onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=273088&p=uiwkjyoexlaoobpdmcsimcsi", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
      alt="logo-samandehi"
      src="https://logo.samandehi.ir/logo.aspx?id=273088&p=odrfyndtqftilymaaqgwaqgw"
    />
  </div>
  <div class="all-right-reserved">
    <span class="title">تمامی حقوق این وب‌سایت متعلق به شرکت ایپام (ایده پرداز دانش نوین آرشام) ‌می‌باشد .</span>
    <div class="social-networks">
      <!-- <i class="item" [inlineSVG]="'assets/icons/whatsapp.svg'"></i> -->
      <a href="https://instagram.com/ipaam_fintech">
        <i class="item" [inlineSVG]="'assets/icons/instagram.svg'"> </i>
      </a>
      <a href="https://www.linkedin.com/company/gardeshpay/mycompany/?viewAsMember=true">
        <i class="item" [inlineSVG]="'assets/icons/linkedin.svg'"></i>
      </a>
    </div>
  </div>
</footer>
